







































import Vue from "vue";
import { Component } from "vue-property-decorator";
import LookupTest from "@/views/lookups/_LookupTest.vue";
import RiskProfileWidget from "@/views/riskProfile/RiskProfileWidget.vue";
import FactFindWidget from "@/views/factFind/FactFindWidget.vue";
import { RoleStore, UserStore } from "@/store";
import LoginForm from "@/views/auth/LoginForm.vue";
import ProfileWidget from "@/views/users/ProfileWidget.vue";
import Policies from "@/views/policies/Policies.vue";
import BrokerHome from "@/views/broker/BrokerHome.vue";
import PortfolioWidget from "@/views/policies/PortfolioWidget.vue";
import router, { ROUTES } from "@/router";
import AdvisorHome from "@/views/broker/AdvisorHome.vue";
import TermsConditions from "@/views/broker/TermsConditions.vue";

@Component({
  components: {
    RiskProfileWidget,
    FactFindWidget,
    LoginForm,
    ProfileWidget,
    BrokerHome,
    PortfolioWidget,
    Policies,
    AdvisorHome,
    TermsConditions
  }
})
export default class Home extends Vue {
  get CanAccessRiskProfile(): boolean {
    return RoleStore.isRiskProfileUser;
  }

  get CanAccessFactFind(): boolean {
    return RoleStore.isFactFindUser;
  }

  get IsUserLoggedIn(): boolean {
    return UserStore.isUserLoggedIn;
  }

  get IsClient(): boolean {
    return RoleStore.isClient;
  }
  get IsBrokerClient(): boolean {
    return RoleStore.isBrokerClient;
  }
  get IsExternalBroker(): boolean {
    return RoleStore.isExternalBroker;
  }

  get IsAdvisor(): boolean {
    return RoleStore.isAnAdvisor;
  }

  get ProfileId(): number {
    return UserStore.profileId;
  }
  get TermCondition(): boolean {
    return UserStore.isTerm;
  }
}
